<template>
  <div id="app" class="content">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <router-link class="navbar-brand mr-auto" to="/about" exact>
          <a class="navbar-brand" href="/about">
            <img src="~@/assets/img/IMVM.png" alt="IMVM" height="70px" width="180px"/>
          </a>
          <h1>Company Performance Index</h1>
        </router-link>
        <NavBar class="navbar" :sitemap="sitemap"/>
        <transition name="slide-fade" mode="out-in">
          <keep-alive>
            <router-view class="mx-auto"/>
          </keep-alive>
        </transition>
        <!-- <Footer :sitemap="sitemap"/> -->
        <!-- <MoveTop /> -->
      </div>
    </div>
  </div>
</template>

<script>
  window.$ = window.JQuery = require('jquery');

  require('bootstrap');
  require('bootstrap/dist/css/bootstrap.min.css');

  import NavBar from '@/components/NavBar.vue';
  // import Footer from '@/components/Footer.vue';
  // import MoveTop from '@/components/MoveTop.vue';

  export default {
    name: 'app',
    components: {
      NavBar,
      // Footer,
      // MoveTop
    },
    data() {
      return {
        authenticated: false,
        mockAccount: {
            username: "test",
            password: "test"
        },
        sitemap: [
          { name: "Home", url: "/about", icon: "icon-small icon-home"},
          { name: "Methodology", url: "/methodology", icon: "icon-small icon-home"},
          { name: "Calculator", url: "/calculator", icon: "icon-small icon-home"},
          { name: "Data", url: "/data", icon: "icon-small icon-home"},
          { name: "Downloads", url: "/downloads", icon: "icon-small icon-home"},
          { name: "Team", url: "/team", icon: "icon-small icon-home"}
        ]
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/css/_variables.scss';
  @import '@/assets/css/global.scss';
  //@import '@/assets/css/icons.scss';
  @import '@/assets/css/animations.scss';

  .navbar {
    margin-bottom: 3em;
  }

  .navbar-brand h1 {
    display: inline;
    vertical-align: middle;
    color: $font_color3;
    font-size: 2.4em;
  }

  @media screen and (max-width: 991px) {
    .content {
      padding: 60px 20px;
    }

    .navbar-brand h1 {
      font-size: 1.5em;
    }
  }

  @media screen and (max-width: 767px) {
    .content h1 {
      font-size: 2em;
      margin-top: 20px;
    }

    .navbar-brand h1 {
      font-size: 0.7em;
    }

    .navbar {
      margin-bottom: 1em;
    }
  }


</style>
